<template>
  <div class="flex align-items-center justify-content-center">
    <div
      class="flex flex-wrap card-container bg-blue-100 border-round"
      style="max-width: 800px; margin: 5px 1px"
    >
      <div class="flex flex-column align-items-center justify-content-center">
        <div class="flex align-items-center justify-content-center" style="width: 100%">
          <div style="margin: 10px; width: 100%">
            <span style="font-size: 18px; text-decoration: underline; margin-bottom: 10px"
              >Soll das Heimrecht mit dem Rückspiel getauscht werden (nur möglich bei
              Hinspielen) oder das Heimrecht nur für dieses Spiel geändert werden?</span
            >
            <SelectButton
              style="margin-top: 25px"
              v-model="selectedOption"
              :options="selectOptions"
              optionDisabled="disabled"
              optionLabel="label"
              @change="updateSwitch"
            />
          </div>
        </div>

        <div class="flex align-items-center justify-content-center" style="width: 100%">
          <div style="margin: 10px; width: 100%">
            <label style="font-size: 18px; text-decoration: underline"
              >Spielerleiter-Bemerkung
            </label>
            <Textarea
              v-model="recordModel.baseRecord.gameManagerNotes"
              :autoResize="false"
              style="width: 100%; height: 30vh; margin-top: 5px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServerConnection from "../../../../services/ServerConnection/ServerConnection";
import AbstractWizardPage from "../../AbstractWizardPage";
import SelectButton from "primevue/selectbutton";
import Textarea from "primevue/textarea";
export default {
  name: "SwitchHomeGuestPage1",
  extends: AbstractWizardPage,
  components: {
    SelectButton,
    Textarea,
  },
  data() {
    return {
      rematchGame: {},
      selectedOption: {},
      selectOptions: [
        {
          value: "yes",
          label: "Heimrecht mit Rückspiel tauschen",
          disabled: false,
        },
        {
          value: "no",
          label: "Heimrecht für dieses Spiel ändern",
          disabled: false,
        },
      ],
    };
  },
  computed: {},
  created() {
    this.loadRematch();
  },
  updated() {
    this.loadRematch();
  },
  methods: {
    loadRematch() {
      if (!this.rematchGame || !this.rematchGame.id) {
        ServerConnection.get("data/game/" + this.recordModel.baseRecord.id + "/rematch")
          .then((resp) => {
            this.rematchGame = resp.data;
            if (this.rematchGame && this.rematchGame.id) {
              if (this.isRematchGame()) {
                this.selectOptions
                  .filter((opt) => opt.value == "yes")
                  .forEach((opt) => (opt.disabled = true));
                this.recordModel.switchRematch = false;
                this.selectedOption = this.selectOptions[1];
              } else {
                this.selectedOption = this.selectOptions[0];
                this.recordModel.switchRematch = true;
              }
            } else {
              this.selectOptions
                .filter((opt) => opt.value == "yes")
                .forEach((opt) => (opt.disabled = true));
              this.recordModel.switchRematch = false;
              this.selectedOption = this.selectOptions[1];
            }
          })
          .catch((error) => {
            console.error("Error saving the record", error);
          });
      }
    },
    isRematchGame() {
      if (
        this.rematchGame &&
        this.rematchGame.id &&
        this.recordModel.baseRecord &&
        this.recordModel.baseRecord.id
      ) {
        return (
          this.rematchGame.gameDay.numberOfGameDay <
          this.recordModel.baseRecord.gameDay.numberOfGameDay
        );
      }
      return false;
    },
    updateSwitch() {
      this.recordModel.switchRematch =
        this.selectedOption &&
        this.selectedOption.value &&
        this.selectedOption.value == "yes";
    },
    validate() {
      return this.selectedOption && this.selectedOption.value;
    },
  },
};
</script>

<style lang="scss" scoped></style>
